import { Box } from '@mui/system';
import PMAFlags from '../pma/PMAFlags';
import { useState } from 'react';
import { Button, Divider, Typography } from '@mui/material';

export default function PmaSystemSettings({ deployment, onSave }) {
  const [flags, setFlags] = useState({
    isMaintenanceActive: deployment?.config?.isMaintenanceActive || false,
    isSyncingAccepted: deployment?.config?.isSyncingAccepted || false,
    startThreshold: Number(deployment?.config?.startThreshold) || 30,
  });

  const handleFlagChange = (flag) => {
    setFlags((prev) => ({
      ...prev,
      [flag]: !prev[flag],
    }));
  };

  const handleFlagChangeWithValue = (flag, value) => {
    setFlags((prev) => ({
      ...prev,
      [flag]: value,
    }));
  };

  const handleSave = () => {
    onSave(flags);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ my: 1, mb: 2, pr: '80px' }}>
        <Typography variant="h6">Systemeinstellungen</Typography>
        <Divider />
      </Box>
      <PMAFlags
        deployment={deployment}
        flags={flags}
        onFlagChange={handleFlagChange}
        handleFlagChangeWithValue={handleFlagChangeWithValue}
        showWithCard={false}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={handleSave}
        sx={{ mt: 'auto', ml: 'auto' }} // This pushes the button to the bottom right
      >
        Speichern
      </Button>
    </Box>
  );
}
